import { Suspense } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import useMyTheme from '../hooks/useMyTheme';
import { getAuthCssVariables } from '../theme/authTheme';
import './BlankLayout.css';

const { Content } = Layout;

const BlankLayout = ({ centered = true, contentClassName = '' }) => {
  const { isDark, token } = useMyTheme();

  return (
    <Layout
      className={`blank_layout ${isDark ? 'blank_layout_dark' : ''}`}
      style={getAuthCssVariables(token)}
    >
      <Content
        className={`blank_layout_content ${
          centered
            ? 'blank_layout_content_centered'
            : 'blank_layout_content_start'
        } ${contentClassName}`}
      >
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </Content>
    </Layout>
  );
};

export default BlankLayout;
